const userSelectionOptionsMap = {
    zh_CN: {
        orgAttributes: [
            {
                name: '第一级组织',
                mark: 'ONE_LEVEL,1',
                type: 0
            },
            {
                name: '第二级组织',
                mark: 'TWO_LEVEL,2',
                type: 0
            },
            {
                name: '第三级组织',
                mark: 'THREE_LEVEL,3',
                type: 0
            },
            {
                name: '第四级组织',
                mark: 'FOUR_LEVEL,4',
                type: 0
            },
            {
                name: '第五级组织',
                mark: 'FIVE_LEVEL,5',
                type: 0
            },
            {
                name: '第六级组织',
                mark: 'SIX_LEVEL,6',
                type: 0
            },
            {
                name: '第七级组织',
                mark: 'SEVEN_LEVEL,7',
                type: 0
            },
            {
                name: '第八级组织',
                mark: 'EIGHT_LEVEL,8',
                type: 0
            },
            {
                name: '第九级组织',
                mark: 'NINE_LEVEL,9',
                type: 0
            },
            {
                name: '第十级组织',
                mark: 'TEN_LEVEL,10',
                type: 0
            },
            {
                name: '第十一级组织',
                mark: 'ELEVEN_LEVEL,11',
                type: 0
            },
            {
                name: '第十二级组织',
                mark: 'TWELVE_LEVEL,12',
                type: 0
            },
            {
                name: '第十三级组织',
                mark: 'THIRTEEN_LEVEL,13',
                type: 0
            },
            {
                name: '第十四级组织',
                mark: 'FOURTEEN_LEVEL,14',
                type: 0
            },
            {
                name: '第十五级组织',
                mark: 'FIFTEN_LEVEL,15',
                type: 0
            },
            {
                name: '第十六级组织',
                mark: 'SIXTEEN_LEVEL,16',
                type: 0
            },
            {
                name: '第十七级组织',
                mark: 'SEVENTEEN_LEVEL,17',
                type: 0
            },
            {
                name: '第十八级组织',
                mark: 'EIGHTTEEN_LEVEL,18',
                type: 0
            },
            {
                name: '第十九级组织',
                mark: 'NINETEEN_LEVEL,19',
                type: 0
            },
            {
                name: '第二十级组织',
                mark: 'TWENTY_LEVEL,20',
                type: 0
            },
            {
                name: '第二十一级组织',
                mark: 'TWENTY_ONE_LEVEL,21',
                type: 0
            },
            {
                name: '第二十二级组织',
                mark: 'TWENTY_TWO_LEVEL,22',
                type: 0
            },
            {
                name: '第二十三级组织',
                mark: 'TWENTY_THREE_LEVEL,23',
                type: 0
            },
            {
                name: '第二十四级组织',
                mark: 'TWENTY_FOUR_LEVEL,24',
                type: 0
            },
            {
                name: '第二十五级组织',
                mark: 'TWENTY_FIVE_LEVEL,25',
                type: 0
            },
            {
                name: '第二十六级组织',
                mark: 'TWENTY_SIX_LEVEL,26',
                type: 0
            },
            {
                name: '第二十七级组织',
                mark: 'TWENTY_SEVEN_LEVEL,27',
                type: 0
            },
            {
                name: '第二十八级组织',
                mark: 'TWENTY_EIGHT_LEVEL,28',
                type: 0
            },
            {
                name: '第二十九级组织',
                mark: 'TWENTY_NINE_LEVEL,29',
                type: 0
            },
            {
                name: '第三十级组织',
                mark: 'THIRTY_LEVEL,30',
                type: 0
            }
        ]
    }
};
export default userSelectionOptionsMap;
